import { GenericService } from './../../generic/generic.service';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/app/core/services/base.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { SalesOrderHeaderDialogComponent } from './sales-order-header-dialog/sales-order-header-dialog.component';
import { PosSearchCustomerDialogComponent } from '../components/pos-search-customer-dialog/pos-search-customer-dialog.component';
import { ConfirmDialogTemplateComponent } from '@optsolservices/ngx-confirm-dialog';
import { SalesOrderScanStockCodeDialogComponent } from './sales-order-scan-stock-code-dialog/sales-order-scan-stock-code-dialog.component';
import { PosStoreService } from '../pos.store.service';
import { SalesOrderLineDialogComponent } from './sales-order-line-dialog/sales-order-line-dialog.component';
import { SalesOrderHeaderCustomerDetailsDialogComponent } from './sales-order-header-customer-details-dialog/sales-order-header-customer-details-dialog.component';
import { SalesOrderCustomerDialogComponent } from './sales-order-customer-dialog/sales-order-customer-dialog.component';
import { NotificationService } from '@optsolservices/ngx-notification';
import { Clipboard } from '@angular/cdk/clipboard';
import { SalesOrderDeliverFeeDialogComponent } from './sales-order-deliver-fee-dialog/sales-order-deliver-fee-dialog.component';
import { SalesOrderLineDiscountDialogComponent } from './sales-order-line-discount-dialog/sales-order-line-discount-dialog.component';
import {
  OiGroupDialogData,
  OiGroupProcessDialogComponent,
} from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';
import { PosAddDepositDialogComponent } from '../components/pos-add-deposit-dialog/pos-add-deposit-dialog.component';
import { PosTfgAccountDetailsComponent } from '../components/pos-tfg-account-details/pos-tfg-account-details.component';
import { SalesOrderInvoiceLinesDialogComponent } from './sales-order-invoice-lines-dialog/sales-order-invoice-lines-dialog.component';
import { PosInvoicePayWithDepositDialogComponent } from '../components/pos-invoice-pay-with-deposit/pos-invoice-pay-with-deposit-dialog.component';
import { PosInvoicePayWithMoneyEquipmentComponent } from '../components/pos-invoice-pay-with-money-equipment/pos-invoice-pay-with-money-equipment.component';
import { SalesOrderCancelDialogComponent } from './sales-order-cancel-dialog/sales-order-cancel-dialog.component';
import { SalesOrderCommentsDialogComponent } from './sales-order-comments-dialog/sales-order-comments-dialog.component';
import { ConfirmWithReasonDialogComponent } from 'src/app/shared/confirm-with-reason-dialog/confirm-with-reason-dialog.component';
import { SysproOrderLineDiscountDialogComponent } from '../syspro-orders/syspro-order-line-discount-dialog/syspro-order-line-discount-dialog.component';
import { SysproOrderLineDialogComponent } from '../syspro-orders/syspro-order-line-dialog/syspro-order-line-dialog.component';
import { SendEmailConfirmDialogComponent } from '../components/send-email-confirm-dialog/send-email-confirm-dialog.component';
import { SalesOrderSearchStockCodeDialogComponent } from './sales-order-search-stock-code-dialog/sales-order-search-stock-code-dialog.component';
import { SalesOrderHeaderDetailsDialogComponent } from './sales-order-header-details-dialog/sales-order-header-details-dialog.component';
import { SalesOrderTransferDepositDialogComponent } from './sales-order-transfer-deposit-dialog/sales-order-transfer-deposit-dialog.component';
import { PrintTriggerDialogComponent } from 'src/app/shared/print-trigger-dialog/print-trigger-dialog.component';
import { PosRefundDepositDialogComponent } from '../components/pos-refund-deposit-dialog/pos-refund-deposit-dialog.component';
import { SalesOrderEftRequestDialogComponent } from './sales-order-eft-request-dialog/sales-order-eft-request-dialog.component';
import { SalesOrderEcomStockCodeSearchDialogComponent } from './sales-order-ecom-stock-code-search-dialog/sales-order-ecom-stock-code-search-dialog.component';
import { SysproOrderUploadSupportingDocumentDialogComponent } from '../syspro-orders/syspro-order-upload-supporting-document-dialog/syspro-order-upload-supporting-document-dialog.component';
import { SendSmsConfirmDialogComponent } from '../components/send-sms-confirm-dialog/send-sms-confirm-dialog.component';
import { SalesOrderAddNoteDialogComponent } from './sales-order-add-note-dialog/sales-order-add-note-dialog.component';
import { SalesOrderLineDetailDialogComponent } from './sales-order-line-detail-dialog/sales-order-line-detail-dialog.component';
import { SysproOrderDeliverFeeDialogComponent } from '../syspro-orders/syspro-order-deliver-fee-dialog/syspro-order-deliver-fee-dialog.component';
import { TfgPaymentReversalComponent } from '../tfg-account/tfg-payment-reversal/tfg-payment-reversal.component';
import { SalesOrderMiscChargeDialogComponent } from './sales-order-misc-charge-dialog/sales-order-misc-charge-dialog.component';
import { SysproOrderMiscChargeDialogComponent } from '../syspro-orders/syspro-order-misc-charge-dialog/syspro-order-misc-charge-dialog.component';
import { CallbackActionDialogComponent } from 'src/app/shared/callback-action-dialog/callback-action-dialog.component';
import { SurveyActionDialogComponent } from 'src/app/shared/survey-action-dialog/survey-action-dialog.component';
import { PosTfgRewardsDetailsDialogComponent } from '../components/pos-tfg-rewards-details-dialog/pos-tfg-rewards-details-dialog.component';
import { PosTfgCampaignDetailsLinesBreakdownComponent } from '../components/pos-tfg-campaign-details/pos-tfg-campaign-details-lines-breakdown/pos-tfg-campaign-details-lines-breakdown.component';
import { PosTfgRewardsCheckVoucherComponent } from '../components/pos-tfg-rewards-check-voucher/pos-tfg-rewards-check-voucher.component';
import { PosTfgRewardsViewVoucherComponent } from '../components/pos-tfg-rewards-view-voucher/pos-tfg-rewards-view-voucher.component';
import { SalesOrderAddNonStockLineComponent } from './sales-order-add-non-stock-line/sales-order-add-non-stock-line.component';
import { SalesOrderLedaineLineDetailDialogComponent } from './sales-order-ledaine-line-detail-dialog/sales-order-ledaine-line-detail-dialog.component';

@Component({
  selector: 'app-sales-orders',
  templateUrl: './sales-orders.component.html',
  styleUrls: ['./sales-orders.component.scss'],
})
export class SalesOrdersComponent implements OnInit, OnDestroy {
  paramSubscription: Subscription;
  mode: string = 'POS'; // POS | SYSPRO

  salesOrder: any;
  compactView: boolean = true;
  showAllTfgCampaigns: boolean = true;

  salesOrderChangedSubscription: Subscription;

  showOrderDetails: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private baseService: BaseService,
    private dialog: MatDialog,
    private router: Router,
    private posStoreService: PosStoreService,
    private genericService: GenericService,
    private clipboard: Clipboard,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.paramSubscription = this.route.params.subscribe((params) => {
      if (this.salesOrderChangedSubscription) {
        this.salesOrderChangedSubscription.unsubscribe();
      }

      if (params['source'] && params['source'] === 'syspro') {
        this.mode = 'SYSPRO';
        this.baseService
          .executeCommand<any>('portal_syspro_order_details_by_id', {
            salesOrderNumber: params['id'],
          })
          .subscribe((response) => {
            if (response.responseCode === 0) {
              this.salesOrder = response.data;

              this.salesOrderChangedSubscription = this.posStoreService
                .salesOrderChanges()
                .subscribe((change) => {
                  if (
                    change &&
                    change.salesOrderHeaderId ===
                      this.salesOrder.salesOrderHeaderId
                  ) {
                    this.refresh();
                  }
                });

              if (
                this.salesOrder.isExpressOrder &&
                this.salesOrder.depositOutstanding >
                  0 /*|| this.salesOrder.invoiceBalance > 0*/
              ) {
                if (this.salesOrder.depositOutstanding > 0) {
                  this.addDeposit();
                }

                // if (this.salesOrder.invoiceBalance > 0) {

                // }
              }
            }
          });
      } else {
        this.mode = 'POS';
        this.baseService
          .executeCommand<any>('portal_sales_order_details_by_id', {
            salesOrderHeaderId: params['id'],
          })
          .subscribe((response) => {
            if (response.responseCode === 0) {
              this.salesOrder = response.data;

              this.salesOrderChangedSubscription = this.posStoreService
                .salesOrderChanges()
                .subscribe((change) => {
                  if (
                    change &&
                    change.salesOrderHeaderId ===
                      this.salesOrder.salesOrderHeaderId
                  ) {
                    this.refresh();
                  }
                });
            }
          });
      }
    });
  }

  ngOnDestroy(): void {
    if (this.paramSubscription) {
      this.paramSubscription.unsubscribe();
    }
    if (this.salesOrderChangedSubscription) {
      this.salesOrderChangedSubscription.unsubscribe();
    }
  }

  refresh() {
    if (this.mode === 'POS') {
      this.baseService
        .executeCommand<any>('portal_sales_order_details_by_id', {
          salesOrderHeaderId: this.salesOrder.salesOrderHeaderId,
        })
        .subscribe((response) => {
          if (response.responseCode === 0) {
            this.salesOrder = response.data;
          }
        });
    } else {
      this.baseService
        .executeCommand<any>('portal_syspro_order_details_by_id', {
          salesOrderNumber: this.salesOrder.salesOrderNumber,
        })
        .subscribe((response) => {
          if (response.responseCode === 0) {
            this.salesOrder = response.data;
          }
        });
    }
  }

  editSalesPersonDetails() {
    const dialogRef = this.dialog.open(SalesOrderHeaderDialogComponent, {
      width: '450px',
      data: { ...this.salesOrder, mode: this.mode },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.refresh();
      }
    });
  }

  useCashCustomer() {
    const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
      width: '450px',
      data: {
        title: 'Use Cash Customer?',
        text: 'Please confirm you want to use the cash customer linked to your store. This will limit the stock codes you can add to this order.',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showConfirmButton: true,
        showCancelButton: true,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.confirmButtonClicked === true) {
        this.baseService
          .executeCommand<any>(
            'portal_sales_order_header_customer_code_modify',
            {
              salesOrderHeaderId: this.salesOrder.salesOrderHeaderId,
              customerCode: null,
              useCashCustomer: true,
            }
          )
          .subscribe((response) => {
            if (response.responseCode === 0) {
              this.refresh();
            }
          });
      }
    });
  }

  searchCustomer() {
    const dialogRef = this.dialog.open(PosSearchCustomerDialogComponent, {
      width: '90%',
      data: this.salesOrder,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.refresh();
      }
    });
  }

  createSysproCustomer() {
    const dialogRef = this.dialog.open(SalesOrderCustomerDialogComponent, {
      width: '950px',
      data: {
        salesOrderHeaderId: this.salesOrder.salesOrderHeaderId,
        customerCode: null,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result &&
        result.responseCode == 0 &&
        result.data &&
        result.data.groupProcessedSuccessfully === true
      ) {
        this.baseService
          .executeCommand<any>(
            'portal_sales_order_header_add_customer_from_oi_group',
            {
              salesOrderHeaderId: this.salesOrder.salesOrderHeaderId,
              outgoingMessageGroupId: result.data.outgoingMessageGroupId,
            }
          )
          .subscribe((response) => {
            if (response.responseCode === 0) {
              this.refresh();
            }
          });
      } else {
        this.refresh();
      }
    });
  }

  editSysproCustomer() {
    const dialogRef = this.dialog.open(SalesOrderCustomerDialogComponent, {
      width: '950px',
      data: {
        salesOrderHeaderId: this.salesOrder.salesOrderHeaderId,
        customerCode: this.salesOrder.customerCode,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.refresh();
    });
  }

  uploadSupportingDocument() {
    const dialogRef = this.dialog.open(
      SysproOrderUploadSupportingDocumentDialogComponent,
      {
        width: '400px',
        data: {
          salesOrderNumber: this.salesOrder.salesOrderNumber,
        },
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      this.refresh();
    });
  }

  editCustomerDetails() {
    const dialogRef = this.dialog.open(
      SalesOrderHeaderCustomerDetailsDialogComponent,
      {
        width: '450px',
        data: { ...this.salesOrder, mode: this.mode },
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      this.refresh();
    });
  }

  editOrderDetails() {
    const dialogRef = this.dialog.open(SalesOrderHeaderDetailsDialogComponent, {
      width: '450px',
      data: { ...this.salesOrder, mode: this.mode },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.refresh();
    });
  }

  refreshCustomerDetailsFromSyspro() {
    if (this.mode === 'SYSPRO') {
      const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
        width: '450px',
        data: {
          title: 'Refresh Customer Details from SYSPRO?',
          text: 'Are you sure you want to refresh the customer details on this order from the SYSPRO customer? This cannot be undone.',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          showConfirmButton: true,
          showCancelButton: true,
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result.confirmButtonClicked === true) {
          const dialogData: OiGroupDialogData = {
            title: 'Refreshing Customer Details From SYSPRO',
            function:
              'portal_oi_group_syspro_order_reload_customer_details_modify',
            postBody: {
              salesOrderNumber: this.salesOrder.salesOrderNumber,
            },
          };

          const ref = this.dialog.open(OiGroupProcessDialogComponent, {
            data: dialogData,
            width: '450px',
          });

          ref.afterClosed().subscribe((oiResult) => {
            if (oiResult.responseCode === 0) {
              this.notificationService.success(
                'Customer Refreshed From Syspro'
              );
              this.refresh();
            }
          });
        }
      });
    } else {
      const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
        width: '450px',
        data: {
          title: 'Refresh Customer Details from SYSPRO?',
          text: 'Are you sure you want to refresh the customer details on this order from the SYSPRO customer? This cannot be undone.',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          showConfirmButton: true,
          showCancelButton: true,
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result.confirmButtonClicked === true) {
          this.baseService
            .executeCommand<any>(
              'portal_sales_order_header_customer_details_refresh_from_syspro',
              { salesOrderHeaderId: this.salesOrder.salesOrderHeaderId }
            )
            .subscribe((response) => {
              if (response.responseCode === 0) {
                this.refresh();
              }
            });
        }
      });
    }
  }

  scan() {
    const dialogRef = this.dialog.open(SalesOrderScanStockCodeDialogComponent, {
      width: '400px',
      data: { ...this.salesOrder, mode: this.mode },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.refresh();
    });
  }

  searchItemsEcom() {
    const dialogRef = this.dialog.open(
      SalesOrderEcomStockCodeSearchDialogComponent,
      {
        width: '90%',
        // height: '90%',
        data: { ...this.salesOrder, mode: this.mode },
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.refresh();
      }
    });
  }

  searchItems() {
    const dialogRef = this.dialog.open(
      SalesOrderSearchStockCodeDialogComponent,
      {
        width: '90%',
        data: { ...this.salesOrder, mode: this.mode },
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (this.mode === 'SYSPRO') {
          const dialogData: OiGroupDialogData = {
            title: 'Adding line to the order in SYSPRO',
            function: 'portal_oi_group_syspro_order_add_line',
            postBody: {
              salesOrderNumber: this.salesOrder.salesOrderNumber,
              stockCode: result.stockCode,
              qty: result.qty,
            },
          };

          const ref = this.dialog.open(OiGroupProcessDialogComponent, {
            data: dialogData,
            width: '450px',
          });

          ref.afterClosed().subscribe((oiResult) => {
            if (oiResult.responseCode === 0) {
              this.notificationService.success('Line Added');
              this.refresh();
            }
          });
        } else {
          this.baseService
            .executeCommand<any[]>('portal_sales_order_add_stock_code', {
              salesOrderHeaderId: this.salesOrder.salesOrderHeaderId,
              stockCode: result.stockCode,
              qty: result.qty,
            })
            .subscribe((response) => {
              if (response.responseCode === 0) {
                this.refresh();
              }
            });
        }
      }
    });
  }

  editLine(line: any) {
    if (this.mode === 'SYSPRO') {
      const dialogRef = this.dialog.open(SysproOrderLineDialogComponent, {
        width: '600px',
        data: line,
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.refresh();
      });
    } else {
      const dialogRef = this.dialog.open(SalesOrderLineDialogComponent, {
        width: '600px',
        data: line,
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.refresh();
      });
    }
  }

  deleteLine(line: any) {
    if (this.mode === 'SYSPRO') {
      this.baseService
        .executeCommand<any>(
          'portal_syspro_order_line_cancel_dialog_config',
          {}
        )
        .subscribe((response) => {
          if (response.responseCode === 0) {
            const dialogRef = this.dialog.open(
              ConfirmWithReasonDialogComponent,
              {
                width: '450px',
                data: {
                  title: 'Delete Line?',
                  text: 'Are you sure you want to delete this line? This cannot be undone.',
                  confirmButtonText: 'Yes',
                  cancelButtonText: 'No',
                  showConfirmButton: true,
                  showCancelButton: true,
                  reasons: response.data.reasons,
                },
              }
            );

            dialogRef.afterClosed().subscribe((result) => {
              if (result.confirmButtonClicked === true) {
                const dialogData: OiGroupDialogData = {
                  title: 'Removing line from the order in SYSPRO',
                  function: 'portal_oi_group_syspro_order_delete_line',
                  postBody: {
                    salesOrderNumber: this.salesOrder.salesOrderNumber,
                    lineNumber: line.lineNumber,
                    processCode: 'DELETE-LINE',
                    cancelReasonCode: result.reasonCode,
                  },
                };

                const ref = this.dialog.open(OiGroupProcessDialogComponent, {
                  data: dialogData,
                  width: '450px',
                });

                ref.afterClosed().subscribe((oiResult) => {
                  if (oiResult.responseCode === 0) {
                    this.notificationService.success('Line Deleted');
                    this.refresh();
                  }
                });
              }
            });
          }
        });
    } else {
      const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
        width: '450px',
        data: {
          title: 'Delete Line?',
          text: 'Are you sure you want to delete this line? This cannot be undone.',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          showConfirmButton: true,
          showCancelButton: true,
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result.confirmButtonClicked === true) {
          this.baseService
            .executeCommand<any>('portal_sales_order_line_delete', {
              salesOrderHeaderId: this.salesOrder.salesOrderHeaderId,
              lineNumber: line.lineNumber,
            })
            .subscribe((response) => {
              if (response.responseCode === 0) {
                this.refresh();
              }
            });
        }
      });
    }
  }

  copyLine(line: any) {
    if (this.mode === 'SYSPRO') {
      const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
        width: '450px',
        data: {
          title: 'Copy Line?',
          text: 'Are you sure you want to copy this line?',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          showConfirmButton: true,
          showCancelButton: true,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result.confirmButtonClicked === true) {
          const dialogData: OiGroupDialogData = {
            title: 'Copying line on the order in SYSPRO',
            function: 'portal_oi_group_syspro_order_copy_line',
            postBody: {
              salesOrderNumber: this.salesOrder.salesOrderNumber,
              lineNumber: line.lineNumber,
              processCode: 'COPY-LINE',
              cancelReasonCode: result.reasonCode,
            },
          };

          const ref = this.dialog.open(OiGroupProcessDialogComponent, {
            data: dialogData,
            width: '450px',
          });

          ref.afterClosed().subscribe((oiResult) => {
            if (oiResult.responseCode === 0) {
              this.notificationService.success('Line Copied');
              this.refresh();
            }
          });
        }
      });

      // dialogRef.afterClosed().subscribe(result => {
      //   if (result.confirmButtonClicked === true) {
      //     this.baseService.executeCommand<any>('portal_oi_group_syspro_order_copy_line', { salesOrderNumber: this.salesOrder.salesOrderNumber, lineNumber: line.lineNumber })
      //       .subscribe(response => {
      //         if (response.responseCode === 0) {
      //           this.notificationService.success('Line Copied');
      //           this.refresh();
      //         }
      //       });
      //   }
      // });
    } else {
      const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
        width: '450px',
        data: {
          title: 'Copy Line?',
          text: 'Are you sure you want to copy this line?',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          showConfirmButton: true,
          showCancelButton: true,
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result.confirmButtonClicked === true) {
          this.baseService
            .executeCommand<any>('portal_sales_order_line_copy', {
              salesOrderHeaderId: this.salesOrder.salesOrderHeaderId,
              lineNumber: line.lineNumber,
            })
            .subscribe((response) => {
              if (response.responseCode === 0) {
                this.refresh();
              }
            });
        }
      });
    }
  }

  addCoriguard(line: any) {
    if (this.mode === 'SYSPRO') {
      const dialogData: OiGroupDialogData = {
        title: 'Adding Coriguard to line on the order in SYSPRO',
        function: 'portal_oi_group_syspro_order_line_add_coriguard',
        postBody: {
          salesOrderNumber: this.salesOrder.salesOrderNumber,
          lineNumber: line.lineNumber,
          processCode: 'LINE-ADD-CG',
        },
      };

      const ref = this.dialog.open(OiGroupProcessDialogComponent, {
        data: dialogData,
        width: '450px',
      });

      ref.afterClosed().subscribe((oiResult) => {
        if (oiResult.responseCode === 0) {
          this.notificationService.success('Coriguard added to line');
          this.refresh();
        }
      });
    } else {
      const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
        width: '450px',
        data: {
          title: 'Add Coriguard?',
          text: 'Are you sure you want to add Coriguard for this line?',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          showConfirmButton: true,
          showCancelButton: true,
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result.confirmButtonClicked === true) {
          this.baseService
            .executeCommand<any>('portal_sales_order_line_add_coriguard', {
              salesOrderHeaderId: this.salesOrder.salesOrderHeaderId,
              lineNumber: line.lineNumber,
            })
            .subscribe((response) => {
              if (response.responseCode === 0) {
                this.refresh();
              }
            });
        }
      });
    }
  }

  removeCoriguard(line: any) {
    if (this.mode === 'SYSPRO') {
      this.baseService
        .executeCommand<any>(
          'portal_syspro_order_line_cancel_dialog_config',
          {}
        )
        .subscribe((response) => {
          if (response.responseCode === 0) {
            const dialogRef = this.dialog.open(
              ConfirmWithReasonDialogComponent,
              {
                width: '450px',
                data: {
                  title: 'Remove Coriguard?',
                  text: 'Are you sure you want to remove Coriguard from this line?',
                  confirmButtonText: 'Yes',
                  cancelButtonText: 'No',
                  showConfirmButton: true,
                  showCancelButton: true,
                  reasons: response.data.reasons,
                },
              }
            );

            dialogRef.afterClosed().subscribe((result) => {
              if (result.confirmButtonClicked === true) {
                const dialogData: OiGroupDialogData = {
                  title: 'Removing Coriguard from line on the order in SYSPRO',
                  function:
                    'portal_oi_group_syspro_order_line_remove_coriguard',
                  postBody: {
                    salesOrderNumber: this.salesOrder.salesOrderNumber,
                    lineNumber: line.lineNumber,
                    processCode: 'LINE-REMOVE-CG',
                    cancelReasonCode: result.reasonCode,
                  },
                };

                const ref = this.dialog.open(OiGroupProcessDialogComponent, {
                  data: dialogData,
                  width: '450px',
                });

                ref.afterClosed().subscribe((oiResult) => {
                  if (oiResult.responseCode === 0) {
                    this.notificationService.success(
                      'Coriguard removed from line'
                    );
                    this.refresh();
                  }
                });
              }
            });
          }
        });
    } else {
      const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
        width: '450px',
        data: {
          title: 'Remove Coriguard?',
          text: 'Are you sure you want to add Coriguard for this line?',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          showConfirmButton: true,
          showCancelButton: true,
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result.confirmButtonClicked === true) {
          this.baseService
            .executeCommand<any>('portal_sales_order_line_remove_coriguard', {
              salesOrderHeaderId: this.salesOrder.salesOrderHeaderId,
              lineNumber: line.lineNumber,
            })
            .subscribe((response) => {
              if (response.responseCode === 0) {
                this.refresh();
              }
            });
        }
      });
    }
  }

  createNewDraftVersion() {
    const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
      width: '450px',
      data: {
        title: 'Create new version in Draft?',
        text: 'Are you sure you want to create a new draft version of this quote? This will keep the prices as currently set on this quote.',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showConfirmButton: true,
        showCancelButton: true,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.confirmButtonClicked === true) {
        this.baseService
          .executeCommand<any>('portal_sales_order_header_copy_to_new_order', {
            salesOrderHeaderId: this.salesOrder.salesOrderHeaderId,
            copyAsNewVersion: true,
          })
          .subscribe((response) => {
            if (response.responseCode === 0) {
              this.genericService.performAction(
                response.data.action,
                null,
                null
              );
            }
          });
      }
    });
  }

  copyLinesToNewDraft() {
    const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
      width: '450px',
      data: {
        title: 'Copy Lines to a New Draft Order?',
        text: 'Are you sure you want to copy all the lines and customer details to a new draft order? This will calculate new prices based on the latest SYSPRO setup.',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showConfirmButton: true,
        showCancelButton: true,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (this.mode === 'SYSPRO') {
        if (result.confirmButtonClicked === true) {
          this.baseService
            .executeCommand<any>(
              'portal_syspro_order_header_copy_to_new_order',
              { salesOrderNumber: this.salesOrder.salesOrderNumber }
            )
            .subscribe((response) => {
              if (response.responseCode === 0) {
                this.genericService.performAction(
                  response.data.action,
                  null,
                  null
                );
              }
            });
        }
      } else {
        if (result.confirmButtonClicked === true) {
          this.baseService
            .executeCommand<any>(
              'portal_sales_order_header_copy_to_new_order',
              {
                salesOrderHeaderId: this.salesOrder.salesOrderHeaderId,
                copyAsNewVersion: false,
              }
            )
            .subscribe((response) => {
              if (response.responseCode === 0) {
                this.genericService.performAction(
                  response.data.action,
                  null,
                  null
                );
              }
            });
        }
      }
    });
  }

  convertToQuote() {
    const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
      width: '450px',
      data: {
        title: 'Convert to Quote?',
        text: 'Are you sure you want to convert this draft order to a formal quote?',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showConfirmButton: true,
        showCancelButton: true,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.confirmButtonClicked === true) {
        this.baseService
          .executeCommand<any>('portal_sales_order_header_convert_to_quote', {
            salesOrderHeaderId: this.salesOrder.salesOrderHeaderId,
          })
          .subscribe((response) => {
            if (response.responseCode === 0) {
              this.refresh();
            }
          });
      }
    });
  }

  createSysproOrder() {
    const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
      width: '450px',
      data: {
        title: 'Create SYSPRO Order?',
        text: `Are you sure you want to create a SYSPRO Order from this ${this.salesOrder.orderType}?`,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showConfirmButton: true,
        showCancelButton: true,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.confirmButtonClicked === true) {
        const dialogData: OiGroupDialogData = {
          title: 'Creating your Order in SYSPRO',
          function: 'portal_oi_group_sales_order_header_create_syspro_order',
          postBody: { salesOrderHeaderId: this.salesOrder.salesOrderHeaderId },
        };

        const ref = this.dialog.open(OiGroupProcessDialogComponent, {
          data: dialogData,
          width: '450px',
        });

        ref.afterClosed().subscribe((oiResult) => {
          this.baseService
            .executeCommand<any>('portal_sales_order_details_by_id', {
              salesOrderHeaderId: this.salesOrder.salesOrderHeaderId,
            })
            .subscribe((response) => {
              if (response.responseCode === 0) {
                this.salesOrder = response.data;
                if (this.salesOrder.erpSalesOrderNumber) {
                  this.router.navigate([
                    '/pos/orders/syspro/' + this.salesOrder.erpSalesOrderNumber,
                  ]);
                }
              }
            });
        });
      }
    });
  }

  downloadResource(resource: any) {
    this.baseService.downloadResource(
      resource.apiResourceKey,
      resource.fileName,
      resource.mimeType
    );
  }

  copyLink(paymentLink) {
    this.clipboard.copy(paymentLink.link);
    this.notificationService.success(`Payment link copied to clipboard!`);
  }

  deleteDeliveryFee(line: any) {
    if (this.mode === 'SYSPRO') {
      this.baseService
        .executeCommand<any>(
          'portal_syspro_order_line_cancel_dialog_config',
          {}
        )
        .subscribe((response) => {
          if (response.responseCode === 0) {
            const dialogRef = this.dialog.open(
              ConfirmWithReasonDialogComponent,
              {
                width: '450px',
                data: {
                  title: 'Remove Delivery Fee?',
                  text: 'Are you sure you want to remove the delivery fee?.',
                  confirmButtonText: 'Yes',
                  cancelButtonText: 'No',
                  showConfirmButton: true,
                  showCancelButton: true,
                  reasons: response.data.reasons,
                },
              }
            );

            dialogRef.afterClosed().subscribe((result) => {
              if (result.confirmButtonClicked === true) {
                const dialogData: OiGroupDialogData = {
                  title: 'Removing Delivery Fee From Order In Syspro',
                  function: 'portal_oi_group_syspro_order_remove_delivery_fee',
                  postBody: {
                    salesOrderNumber: this.salesOrder.salesOrderNumber,
                    lineNumber: line.lineNumber,
                    processCode: 'DELETE-DELIVERY-FEE',
                    cancelReasonCode: result.reasonCode,
                  },
                };

                const ref = this.dialog.open(OiGroupProcessDialogComponent, {
                  data: dialogData,
                  width: '450px',
                });

                ref.afterClosed().subscribe((oiResult) => {
                  if (oiResult.responseCode === 0) {
                    this.notificationService.success('Delivery Fee Removed');
                    this.refresh();
                  }
                });
              }
            });
          }
        });
    } else {
      const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
        width: '450px',
        data: {
          title: 'Delete Line?',
          text: 'Are you sure you want to delete this line?',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          showConfirmButton: true,
          showCancelButton: true,
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result.confirmButtonClicked === true) {
          this.baseService
            .executeCommand<any>('portal_sales_order_line_delete', {
              salesOrderHeaderId: this.salesOrder.salesOrderHeaderId,
              lineNumber: line.lineNumber,
            })
            .subscribe((response) => {
              if (response.responseCode === 0) {
                this.refresh();
              }
            });
        }
      });
    }
  }

  deleteMiscCharge(line: any) {
    if (this.mode === 'SYSPRO') {
      this.baseService
        .executeCommand<any>(
          'portal_syspro_order_line_cancel_dialog_config',
          {}
        )
        .subscribe((response) => {
          if (response.responseCode === 0) {
            const dialogRef = this.dialog.open(
              ConfirmWithReasonDialogComponent,
              {
                width: '450px',
                data: {
                  title: 'Remove Misc Service Charge?',
                  text: 'Are you sure you want to remove the misc. service charge?.',
                  confirmButtonText: 'Yes',
                  cancelButtonText: 'No',
                  showConfirmButton: true,
                  showCancelButton: true,
                  reasons: response.data.reasons,
                },
              }
            );

            dialogRef.afterClosed().subscribe((result) => {
              if (result.confirmButtonClicked === true) {
                const dialogData: OiGroupDialogData = {
                  title: 'Removing Misc. Service Charge From Order In Syspro',
                  function: 'portal_oi_group_syspro_order_remove_delivery_fee', // TODO: Write a new similar proc for service charges
                  postBody: {
                    salesOrderNumber: this.salesOrder.salesOrderNumber,
                    lineNumber: line.lineNumber,
                    processCode: 'DELETE-MISC-SERVICE-CHARGE',
                    cancelReasonCode: result.reasonCode,
                  },
                };

                const ref = this.dialog.open(OiGroupProcessDialogComponent, {
                  data: dialogData,
                  width: '450px',
                });

                ref.afterClosed().subscribe((oiResult) => {
                  if (oiResult.responseCode === 0) {
                    this.notificationService.success(
                      'Misc Service Charge Removed'
                    );
                    this.refresh();
                  }
                });
              }
            });
          }
        });
    } else {
      const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
        width: '450px',
        data: {
          title: 'Delete Line?',
          text: 'Are you sure you want to delete this line?',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          showConfirmButton: true,
          showCancelButton: true,
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result.confirmButtonClicked === true) {
          this.baseService
            .executeCommand<any>('portal_sales_order_line_delete', {
              salesOrderHeaderId: this.salesOrder.salesOrderHeaderId,
              lineNumber: line.lineNumber,
            })
            .subscribe((response) => {
              if (response.responseCode === 0) {
                this.refresh();
              }
            });
        }
      });
    }
  }

  addDeliverFee() {
    if (this.mode === 'SYSPRO') {
      const dialogRef = this.dialog.open(SysproOrderDeliverFeeDialogComponent, {
        width: '450px',
        data: { ...this.salesOrder, mode: this.mode },
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.refresh();
      });
    } else {
      const dialogRef = this.dialog.open(SalesOrderDeliverFeeDialogComponent, {
        width: '450px',
        data: this.salesOrder,
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.refresh();
      });
    }
  }

  addMiscCharge() {
    if (this.mode === 'SYSPRO') {
      const dialogRef = this.dialog.open(SysproOrderMiscChargeDialogComponent, {
        width: '450px',
        data: { ...this.salesOrder, mode: this.mode },
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.refresh();
      });
    } else {
      const dialogRef = this.dialog.open(SalesOrderMiscChargeDialogComponent, {
        width: '450px',
        data: this.salesOrder,
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.refresh();
      });
    }
  }

  modifyLineDiscount(line: any) {
    if (this.mode === 'SYSPRO') {
      const dialogRef = this.dialog.open(
        SysproOrderLineDiscountDialogComponent,
        {
          width: '500px',
          data: line,
        }
      );

      dialogRef.afterClosed().subscribe((result) => {
        this.refresh();
      });
    } else {
      const dialogRef = this.dialog.open(
        SalesOrderLineDiscountDialogComponent,
        {
          width: '500px',
          data: line,
        }
      );

      dialogRef.afterClosed().subscribe((result) => {
        this.refresh();
      });
    }
  }

  addDeposit() {
    const ref = this.dialog.open(PosAddDepositDialogComponent, {
      data: this.salesOrder,
      width: '800px',
    });

    ref.afterClosed().subscribe((response) => {
      this.baseService
        .executeCommand<any>('portal_syspro_order_details_by_id', {
          salesOrderNumber: this.salesOrder.salesOrderNumber,
        })
        .subscribe((response) => {
          if (response.responseCode === 0) {
            this.salesOrder = response.data;

            if (this.salesOrder.isExpressOrder) {
              if (this.salesOrder.depositOutstanding === 0) {
                this.tryToInvoiceExpressOrder();
              }
            }
          }
        });
    });
  }

  tryToInvoiceExpressOrder() {
    const lines = (this.salesOrder.lines || [])
      .filter((f) => f.shipQty > 0)
      .map((m) => m.lineNumber);
    if (lines && lines.length > 0) {
      const dialogData: OiGroupDialogData = {
        title: 'Creating Invoice',
        function: 'portal_oi_group_sales_order_create_invoice',
        postBody: {
          salesOrderNumber: this.salesOrder.erpSalesOrderNumber,
          lines: lines,
          linesString: lines.join(','),
        },
      };

      const ref = this.dialog.open(OiGroupProcessDialogComponent, {
        data: dialogData,
        width: '450px',
      });

      ref.afterClosed().subscribe((oiResult) => {
        if (
          oiResult.responseCode === 0 &&
          oiResult.data &&
          oiResult.data.groupProcessedSuccessfully === true
        ) {
          this.baseService
            .executeCommand<any>('portal_syspro_order_details_by_id', {
              salesOrderNumber: this.salesOrder.salesOrderNumber,
            })
            .subscribe((response) => {
              if (response.responseCode === 0) {
                this.salesOrder = response.data;

                if (
                  this.salesOrder.isExpressOrder &&
                  this.salesOrder.invoices &&
                  this.salesOrder.invoices.length === 1
                ) {
                  const invoice = this.salesOrder.invoices.find(
                    (f) => f.canCreateInvoice === true
                  );
                  if (invoice) {
                    this.generateInvoiceDocument(invoice);
                  }
                }
              }
            });
        }
      });
    }
  }

  linkTfgAccount() {
    const ref = this.dialog.open(PosTfgAccountDetailsComponent, {
      data: this.salesOrder,
      width: '70%',
    });

    ref.afterClosed().subscribe((response) => {
      this.refresh();
    });
  }

  viewTfgAccount() {
    const ref = this.dialog.open(PosTfgAccountDetailsComponent, {
      data: this.salesOrder,
      width: '70%',
    });

    ref.afterClosed().subscribe((response) => {
      this.refresh();
    });
  }

  linkTfgRewardsAccount() {
    const ref = this.dialog.open(PosTfgRewardsDetailsDialogComponent, {
      data: this.salesOrder,
      width: '70%',
    });

    ref.afterClosed().subscribe((response) => {
      this.refresh();
    });
  }

  viewTfgRewardsAccount() {
    const ref = this.dialog.open(PosTfgRewardsDetailsDialogComponent, {
      data: this.salesOrder,
      width: '70%',
    });

    ref.afterClosed().subscribe((response) => {
      this.refresh();
    });
  }

  invoiceLines() {
    const ref = this.dialog.open(SalesOrderInvoiceLinesDialogComponent, {
      data: this.salesOrder,
      width: '1000px',
    });

    ref.afterClosed().subscribe((response) => {
      this.refresh();
    });
  }

  payInvoiceWithDeposit(invoice: any) {
    const ref = this.dialog.open(PosInvoicePayWithDepositDialogComponent, {
      data: invoice,
      width: '500px',
    });

    ref.afterClosed().subscribe((response) => {
      this.refresh();
    });
  }

  payInvoice(invoice: any) {
    const ref = this.dialog.open(PosInvoicePayWithMoneyEquipmentComponent, {
      data: invoice,
      width: '800px',
    });

    ref.afterClosed().subscribe((response) => {
      this.refresh();
    });
  }

  cancelOrderDialog() {
    if (this.mode === 'SYSPRO') {
      this.baseService
        .executeCommand<any>('portal_syspro_order_cancel_dialog_config', {})
        .subscribe((response) => {
          if (response.responseCode === 0) {
            const dialogRef = this.dialog.open(
              ConfirmWithReasonDialogComponent,
              {
                width: '450px',
                data: {
                  title: 'Cancel Order?',
                  text: 'Are you sure you want to cancel this order?',
                  confirmButtonText: 'Yes',
                  cancelButtonText: 'No',
                  showConfirmButton: true,
                  showCancelButton: true,
                  reasons: response.data.reasons,
                },
              }
            );

            dialogRef.afterClosed().subscribe((result) => {
              if (result.confirmButtonClicked === true) {
                const dialogData: OiGroupDialogData = {
                  title: 'Cancelling order in SYSPRO',
                  function: 'portal_oi_group_syspro_order_cancel',
                  postBody: {
                    salesOrderNumber: this.salesOrder.salesOrderNumber,
                    processCode: 'CANCEL-ORDER',
                    cancelReasonCode: result.reasonCode,
                  },
                };

                const ref = this.dialog.open(OiGroupProcessDialogComponent, {
                  data: dialogData,
                  width: '450px',
                });

                ref.afterClosed().subscribe((oiResult) => {
                  if (oiResult.responseCode === 0) {
                    this.notificationService.success('Order Cancelled');
                    this.refresh();
                  }
                });
              }
            });
          }
        });
    } else {
      this.baseService
        .executeCommand<any[]>(
          'portal_sales_order_header_cancel_dialog_config',
          { salesOrderHeaderId: this.salesOrder.salesOrderHeaderId }
        )
        .subscribe((response) => {
          if (response.responseCode === 0) {
            if (response.data.length > 1) {
              const ref = this.dialog.open(SalesOrderCancelDialogComponent, {
                data: response.data,
                width: '500px',
              });

              ref.afterClosed().subscribe((dialogResult) => {
                if (dialogResult) {
                  this.cancelOrder(dialogResult.cancelAllVersions);
                } else {
                  this.refresh();
                }
              });
            } else {
              const dialogRef = this.dialog.open(
                ConfirmDialogTemplateComponent,
                {
                  width: '450px',
                  data: {
                    title: 'Cancel Order?',
                    text: `Are you sure you want to cancel this ${this.salesOrder.orderType}?`,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showConfirmButton: true,
                    showCancelButton: true,
                  },
                }
              );

              dialogRef.afterClosed().subscribe((result) => {
                if (result.confirmButtonClicked === true) {
                  this.cancelOrder(false);
                }
              });
            }
          }
        });
    }
  }

  cancelOrder(cancelAllVersions: boolean) {
    this.baseService
      .executeCommand<any[]>('portal_sales_order_header_cancel', {
        salesOrderHeaderId: this.salesOrder.salesOrderHeaderId,
        cancelAllVersions: cancelAllVersions,
      })
      .subscribe((response) => {
        if (response.responseCode === 0) {
          this.refresh();
        }
      });
  }

  showComments(comments: any[]) {
    this.dialog.open(SalesOrderCommentsDialogComponent, {
      width: '450px',
      data: comments,
    });
  }

  viewDetails(dataItem: any) {
    this.dialog.open(SalesOrderLineDetailDialogComponent, {
      width: '80%',
      data: dataItem,
    });
  }

  generateInvoiceDocument(dataItem: any) {
    const ref = this.dialog.open(PrintTriggerDialogComponent, {
      data: {
        title: 'Generating Invoice Document',
        function: 'portal_syspro_order_create_print_trigger',
        postBody: dataItem,
      },
      width: '600px',
    });

    ref.afterClosed().subscribe((response) => {
      this.baseService
        .executeCommand<any>('portal_syspro_order_details_by_id', {
          salesOrderNumber: this.salesOrder.salesOrderNumber,
        })
        .subscribe((response) => {
          if (response.responseCode === 0) {
            this.salesOrder = response.data;

            if (
              this.salesOrder.isExpressOrder &&
              this.salesOrder.invoices &&
              this.salesOrder.invoices.length === 1
            ) {
              const invoice = this.salesOrder.invoices.find(
                (f) => f.canDownloadInvoice === true
              );
              if (invoice) {
                this.emailDocument(invoice.email);
              }
            }
          }
        });
    });
  }

  generateReceiptDocument(dataItem: any) {
    const ref = this.dialog.open(PrintTriggerDialogComponent, {
      data: {
        title: 'Generating Proof of Payment',
        function: 'portal_syspro_order_create_print_trigger',
        postBody: dataItem,
      },
      width: '600px',
    });

    ref.afterClosed().subscribe((response) => {
      this.refresh();
    });
  }

  emailDocument(emailInfo: any) {
    const dialogRef = this.dialog.open(SendEmailConfirmDialogComponent, {
      width: '450px',
      data: {
        createEmailFunction: 'portal_syspro_order_create_email',
        email: emailInfo,
        form: {
          name: this.salesOrder.customerName,
          email: this.salesOrder.email,
        },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.refresh();
    });
  }

  detailToggleChange(event: any) {
    this.showOrderDetails = event.checked;
  }

  tfgCampaignToggleChange(event: any) {
    this.showAllTfgCampaigns = event.checked;
  }

  refundDeposit() {
    const ref = this.dialog.open(PosRefundDepositDialogComponent, {
      data: this.salesOrder,
      width: '800px',
    });

    ref.afterClosed().subscribe((response) => {
      this.refresh();
    });
  }

  transferDeposit() {
    const ref = this.dialog.open(SalesOrderTransferDepositDialogComponent, {
      data: this.salesOrder,
      width: '600px',
    });

    ref.afterClosed().subscribe((response) => {
      this.refresh();
    });
  }

  eftRefundRequest() {
    const ref = this.dialog.open(SalesOrderEftRequestDialogComponent, {
      data: this.salesOrder,
      width: '600px',
    });

    ref.afterClosed().subscribe((formValue) => {
      if (formValue) {
        this.baseService
          .executeCommand<any>(
            'portal_pos_payment_create_eft_deposit_refund_request',
            formValue
          )
          .subscribe((response) => {
            this.refresh();
          });
      } else {
        this.refresh();
      }
    });
  }

  sendSMS() {
    const ref = this.dialog.open(SendSmsConfirmDialogComponent, {
      data: this.salesOrder,
      width: '400px',
    });

    ref.afterClosed().subscribe((formValue) => {
      this.refresh();
    });
  }

  deleteSupportingDocument(dataItem: any) {
    const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
      width: '450px',
      data: {
        title: 'Delete Supporting Document?',
        text: `Please confirm you want to delete the supporting document (${dataItem.resourceType}). This is not reversable.`,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showConfirmButton: true,
        showCancelButton: true,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.confirmButtonClicked === true) {
        this.baseService
          .executeCommand<any>(
            'portal_sales_order_supporting_document_delete',
            { resourceFileId: dataItem.resourceFileId }
          )
          .subscribe((response) => {
            if (response.responseCode === 0) {
              this.refresh();
            }
          });
      }
    });
  }

  addNote() {
    const ref = this.dialog.open(SalesOrderAddNoteDialogComponent, {
      data: this.salesOrder,
      width: '400px',
    });

    ref.afterClosed().subscribe((formValue) => {
      this.refresh();
    });
  }

  deleteNote(dataItem: any) {
    console.log('dataItem: ', dataItem);
    dataItem.salesOrderNoteActive = false;
    this.baseService
      .executeCommand('portal_sales_order_note_modify', {
        salesOrderHeaderId: this.salesOrder.salesOrderHeaderId,
        salesOrderNumber: this.salesOrder.salesOrderNumber,
        ...dataItem,
      })
      .subscribe((response) => {
        if (response.responseCode === 0) {
          this.refresh();
        }
      });
  }

  generateTfgDocument(document: any) {
    const ref = this.dialog.open(PrintTriggerDialogComponent, {
      data: {
        title: 'Generating TFG Payment Receipt',
        function: 'portal_tfg_account_create_print_trigger',
        postBody: document,
      },
      width: '600px',
    });

    ref.afterClosed().subscribe((response) => {
      this.refresh();
    });
  }

  downloadTfgResource(resource: any) {
    this.baseService.downloadResource(
      resource.apiResourceKey,
      resource.fileName,
      resource.mimeType
    );
  }

  reverseTfgOtbPayment(dataItem: any) {
    const dialogRef = this.dialog.open(TfgPaymentReversalComponent, {
      width: '900px',
      data: dataItem,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.refresh();
    });
  }

  resendQuote(resource: any) {
    const dialogRef = this.dialog.open(SendEmailConfirmDialogComponent, {
      width: '450px',
      data: {
        createEmailFunction: 'portal_cc_customer_email_send_quote_confirmation',
        email: resource,
        form: {
          name: this.salesOrder.customerName,
          email: this.salesOrder.email,
        },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.refresh();
    });
  }

  resendPop(resource: any) {
    const dialogRef = this.dialog.open(SendEmailConfirmDialogComponent, {
      width: '450px',
      data: {
        createEmailFunction: 'portal_cc_customer_email_send_proof_of_payment',
        email: resource,
        form: {
          name: this.salesOrder.customerName,
          email: this.salesOrder.email,
        },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.refresh();
    });
  }

  resendCustomerEmail(customerEmail: any) {
    const dialogRef = this.dialog.open(SendEmailConfirmDialogComponent, {
      width: '450px',
      data: {
        createEmailFunction: 'portal_cc_customer_email_resend',
        email: customerEmail,
        form: {
          name: this.salesOrder.customerName,
          email: this.salesOrder.email,
        },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.refresh();
    });
  }

  editCallbackRequest(callbackRequest: any) {
    const dialogRef = this.dialog.open(CallbackActionDialogComponent, {
      data: { callbackOrSurveyId: callbackRequest.callbackRequestId },
    });

    dialogRef.afterClosed().subscribe((dialogResponse) => {
      if (dialogResponse) {
        this.refresh();
      }
    });
  }

  editSurveyResponse(surveyResponse: any) {
    const dialogRef = this.dialog.open(SurveyActionDialogComponent, {
      data: { callbackOrSurveyId: surveyResponse.surveyResponseId },
    });

    dialogRef.afterClosed().subscribe((dialogResponse) => {
      if (dialogResponse) {
        this.refresh();
      }
    });
  }

  hasAttachments(customerEmail: any) {
    return customerEmail.attachments && customerEmail.attachments.length > 0;
  }

  showRewardsLineBreakdown() {
    const ref = this.dialog.open(PosTfgCampaignDetailsLinesBreakdownComponent, {
      data: this.salesOrder.salesOrderHeaderId,
      width: '90%'
    });
  }

  linkTfgVoucher() {
    const ref = this.dialog.open(PosTfgRewardsCheckVoucherComponent, {
      data: {
        salesOrderHeaderId: this.salesOrder.salesOrderHeaderId,
        storeId: this.salesOrder.storeId
      }
    });

    ref.afterClosed().subscribe(dialogResponse => this.refresh());
  }

  viewTfgVoucher(canRemoveVoucher: boolean) {
    this.dialog.open(PosTfgRewardsViewVoucherComponent, {
      data: {
        salesOrderHeaderId: this.salesOrder.salesOrderHeaderId,
        salesOrderNumber: this.salesOrder.salesOrderNumber,
        canRemoveVoucher: canRemoveVoucher,
      }
    }).afterClosed().subscribe(response => this.refresh());
  }

  addExternalLine() {
    this.dialog.open(SalesOrderAddNonStockLineComponent, {
      data: {
        salesOrderHeaderId: this.salesOrder.salesOrderHeaderId,
      },

    }).afterClosed().subscribe(response => this.refresh());
  }

  editNonStockLine(line: any) {
    this.dialog.open(SalesOrderAddNonStockLineComponent, {
      data: {
        salesOrderHeaderId: this.salesOrder.salesOrderHeaderId,
        lineNumber: line.lineNumber,
        nonStockCode: line.displayCode,
        nonStockDesc: line.lineDescription,
        unitRspIncVat: line.unitRspIncludingVat,
        qty: line.orderQty
      },

    }).afterClosed().subscribe(response => this.refresh());
  }

  viewNonStockDetails(dataItem: any) {
    this.dialog.open(SalesOrderLedaineLineDetailDialogComponent, {
      width: '80%',
      data: dataItem,
    });
  }
}
